import { Text } from '@smuchile/pkg-unimarc-components'
import { useMobile } from '@smuchile/pkg-unimarc-hooks'

export const TextFirst = () => {
  const { isMobile } = useMobile()
  const fontSize = isMobile ? 'xl' : '3xl'
  return (
    <Text
      fontSize={fontSize}
      fontWeight='semibold'
      textAlign='center'
    >
      Cancelación en proceso
    </Text>
  )
}
